<button routerLink="/dashboard" routerLinkActive="active">
  <mat-icon svgIcon="dashboard"></mat-icon>
  <span>Dashboard</span>
</button>
<mat-divider></mat-divider>
<ng-container *ngFor="let menu of menuItemsList">
  <button
    (click)="menu.opened = !menu.opened"
    [class.opened]="menu.opened"
    [class.active]="menu.active"
  >
    <span class="badge">{{ menu.children?.length }}</span>
    <span>{{ menu.name }}</span>
    <mat-icon [class.opened]="menu.opened">chevron_right</mat-icon>
  </button>
  <div class="submenu" *ngIf="menu.opened!">
    <a
      [routerLink]="['/' + node.link]"
      routerLinkActive="active"
      *ngFor="let node of menu.children"
    >
      <mat-icon>{{ node.icon }}</mat-icon>
      <span>{{ node.name }}</span>
    </a>
    <mat-divider></mat-divider>
  </div>
  <mat-divider></mat-divider>
</ng-container>
